// AUTO-GENERATED by the PrGuardian.Contracts TypeScript bindings generator - DO NOT EDIT MANUALLY.
// Source of truth: Contracts/PrGuardian.Contracts.csproj
// Regenerate: `dotnet build Contracts/PrGuardian.Contracts.csproj`

// Property casing matches ASP.NET Core System.Text.Json default (camelCase).
// DateTime fields are serialized as ISO-8601 strings.

// PrGuardian.Contracts.Commits

export interface CommitControl {
  commitId?: string | null;
  controlType: ControlType;
  controlId: string;
  controlStatus: number;
  controlMetadata?: string | null;
}

export enum CommitControlStatus {
  NotStarted = 0,
  Stage1 = 1,
  Stage2 = 2,
  KillSwitched = -2,
  NoControls = -1,
}

export interface CommitDetails {
  commitMetaData: CommitMetaData;
  commitControls: CommitControl[];
  commitEvents: CommitEvent[];
  commitMetrics: CommitMetric[];
  regressions: RegressionInfo[];
  functions: Record<number, CommitFunction>;
}

export interface CommitEvent {
  type: ControlType;
  identifier: string;
  action: number;
  farmName: string;
  env: number;
  startTime: string;
  endTime?: string | null;
}

export interface CommitFunction {
  commitId?: string | null;
  methodNameSpace: string;
  className: string;
  methodName: string;
  methodType: string;
  methodArgumentTypes: string;
  sourceFilePath: string;
}

export interface CommitMetaData {
  commitId?: string | null;
  prid?: string | null;
  authorName?: string | null;
  authorEmail?: string | null;
  prmergeDate?: string | null;
  isRegression?: boolean | null;
  projectName?: string | null;
  repositoryName?: string | null;
  isManualRegression?: boolean | null;
  auditor?: string | null;
  title?: string | null;
  deploymentStatus?: number | null;
  deploymentStatusAsString?: string | null;
  controlStatus?: CommitControlStatus | null;
  controlStatusAsString?: string | null;
  dataSources?: number | null;
  regressionMask: number;
}

export interface CommitMetric {
  metricType?: MetricType | null;
  farmMetrics?: FarmMetric[] | null;
}

export interface CommitMetricSubType {
  metricSubType?: string | null;
  commitTimeSeries?: TimeSeries | null;
}

export enum ControlType {
  KillSwitch = 0,
  Flight = 1,
  Deployment = 2,
  Uls = 4,
  Unknown = -1,
}

export interface FarmMetric {
  farm?: string | null;
  env?: number | null;
  process?: number | null;
  metricSubTypes?: CommitMetricSubType[] | null;
}

export enum FlagSource {
  Automation = 0,
  Auditor = 1,
  Summary = 2,
}

export enum MetricType {
  OnCPU = 0,
  OffCPU = 1,
  Exception = 2,
  Memory = 3,
  SqlCount = 4,
  SqlDuration = 5,
  ApiCpu = 6,
  ApiDuration = 7,
  ULS = 8,
  Unknown = -1,
}

export interface RegressionInfo {
  metricType: MetricType;
  environmentId: number;
  processId: number;
  source: FlagSource;
  isRegression: boolean;
  lastModified: string;
  auditorEmail?: string | null;
  auditorName?: string | null;
  classificationType?: number | null;
  additionalComment?: string | null;
  isAuthorDM?: boolean | null;
  channelMessageId?: string | null;
}

export interface TimeData {
  date: string;
  metricValue: number;
  totalOnCpuSamples?: number | null;
  requestCount?: number | null;
  profileUsage?: number | null;
  normalizedProfileUsage?: number | null;
}

export interface TimeSeries {
  data: TimeData[];
}

export interface UlsEvent {
  eventId: string;
  level: UlsLevel;
  introduced: boolean;
  message?: string | null;
  sourceFilePath?: string | null;
  catchContext: boolean;
}

export enum UlsLevel {
  Exception = 0,
  Unexpected = 1,
  Monitorable = 2,
  High = 3,
  Medium = 4,
}

